/**
 *
 * MobileComponent
 *
 */
import React, { memo } from 'react';
import AppleStore from 'assets/icons/Mobile/AppleStore.svg';
import Description from 'assets/icons/Mobile/Description.svg';
import Logo from 'assets/icons/Mobile/Logo.svg';
import MobilePhone from 'assets/icons/Mobile/MobilePhone.webp';
import PlayStore from 'assets/icons/Mobile/PlayStore.svg';
import SubDescription from 'assets/icons/Mobile/SubDescription.svg';
import Text from 'assets/icons/Mobile/Text.svg';
import { ComponentProps } from 'features/Authentication';

export const MobileComponent = memo((props: ComponentProps) => {
  return (
    <div className='flex flex-col items-center gap-6 p-4'>
      <img src={Logo} alt="Logo" />
      <img src={MobilePhone} alt="MobilePhone" />
      <img src={Text} alt="Text" />
      <img src={Description} alt="Description" />
      <img src={SubDescription} alt="SubDescription" />
      <div className="flex justify-center items-center gap-4">
        <div className="cursor-pointer" onClick={() => window.open("https://play.google.com/store/apps/details?id=ai.soomuch.app", "_blank")}><img src={PlayStore} alt="PlayStore" /></div>
        <img src={AppleStore} alt="AppleStore" />
      </div>
    </div>
  );
});
